// extracted by css-extract-rspack-plugin
export default {"modal":"is54z4","backdrop":"s89tfx"};